<template>
    <div id="wrapper" :class="langCss">
        <!-- start header -->
        <header>
            <div class="navbar navbar-default navbar-static-top">
                <div class="container">
                    <div class="navbar-header">
                        <button type="button" class="navbar-toggle" data-toggle="collapse"
                            data-target=".navbar-collapse">
                            <span class="icon-bar"></span>
                            <span class="icon-bar"></span>
                            <span class="icon-bar"></span>
                        </button>
                        <router-link to="/" class="navbar-brand"><img src="/static/img/logo.png" alt="logo" /></router-link>
                    </div>
                    <div class="navbar-collapse collapse ">
                        <ul class="nav navbar-nav">
                            <li><router-link to="/" class="navbar-item">{{ $t('message.home') }}</router-link></li>
                            <li><router-link to="/services" class="navbar-item">{{ $t('message.serve') }}</router-link></li>
                            <!-- <li v-if="langCss != 'cn'"><a href="http://www.cflytrip.com" class="navbar-item" style="color:coral" >{{ $t('message.book') }}</a></li> -->
                            <li><router-link to="/portf" class="navbar-item">{{ $t('message.port') }}</router-link></li>
                            <!-- <li><router-link to="/aboutus" class="navbar-item">{{ $t('message.au') }}</router-link></li> -->
                            <li><router-link to="/pricing" class="navbar-item">{{ $t('message.pric') }}</router-link></li>
                            <li class="active"><router-link to="/contact" class="navbar-item">{{ $t('message.contact') }}</router-link></li>
                        </ul>
                    </div>
                    <div class="ceswich">
                        <button style="background:none;border:none" :class="langCss === 'cn' ? 'xz' : ''"
                                @click="switchLang('cn')">{{ $t('message.switchCn') }}</button> |
                        <button style="background:none;border:none" :class="langCss === 'en' ? 'xz' : ''"
                                @click="switchLang('en')">{{ $t('message.switchEn') }}</button>
                    </div>
                </div>
            </div>
        </header>
        <section id="inner-headline">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <h2 class="pageTitle">{{$t('message.contact')}}</h2>
                    </div>
                </div>
            </div>
        </section>
        <section id="content">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="about-logo">
                            <h3>{{$t('message.contactTit')}}</h3>
                            <p>{{$t('message.contactCon')}}</p>
                            <p>{{$t('message.contactCon2')}}</p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <p></p>
                        <div class="alert alert-success hidden" id="contactSuccess">
                            <strong>Success!</strong> Your message has been sent to us.
                        </div>
                        <div class="alert alert-error hidden" id="contactError">
                            <strong>Error!</strong> There was an error sending your message.
                        </div>
                        <div class="contact-form">
                            <form id="contact-form" role="form" novalidate="novalidate">
                               <input type="hidden" name="isf_methodName" value="abnormalWarn">
                                <div class="form-group has-feedback">
                                    <label for="name">{{$t('message.contactTextName')}}</label>
                                    <input @focus="namefcous()" type="text" class="form-control" v-model="name" id="name" name="SEARCH_PERSONNAME" placeholder="">
                                    <i class="fa fa-user form-control-feedback"></i>
                                    <p v-if="typename"  style="color:red;font-size:12px">{{$t('message.tostName')}}</p>
                                </div>
                                <div class="form-group has-feedback">
                                    <label for="email">{{$t('message.contactTextEmail')}}</label>
                                    <input @focus="emailfcous()" type="email" class="form-control" v-model="email" id="email" name="SEARCH_MAIL" placeholder="">
                                    <i class="fa fa-envelope form-control-feedback"></i>
                                    <p v-if="emailname" style="color:red;font-size:12px">{{$t('message.tostEmail')}}</p>
                                </div>
                                <div class="form-group has-feedback">
                                    <label for="subject">{{$t('message.contactTextSubject')}}</label>
                                    <input @focus="subjectfcous()" type="text" class="form-control" v-model="subject" id="subject" name="SEARCH_THEME" placeholder="">
                                    <i class="fa fa-navicon form-control-feedback"></i>
                                    <p v-if="subjectname" style="color:red;font-size:12px">{{$t('message.tostSubject')}}</p>
                                </div>
                                <div class="form-group has-feedback">
                                    <label for="message">{{$t('message.contactTextMessage')}}</label>
                                    <textarea @focus="messagefcous()" class="form-control" rows="6" v-model="message" id="message" name="SEARCH_CONTENT" placeholder=""></textarea>
                                    <i class="fa fa-pencil form-control-feedback"></i>
                                    <p v-if="messagename" style="color:red;font-size:12px">{{$t('message.tostMessage')}}</p>
                                </div>
                                <input type="submit" :value="$t('message.contactSubmit')" @click.prevent="submit" class="btn btn-default">
                            </form>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="gmaps">
                            <div id="gmap_canvas"></div>
                            <!-- <a class="google-map-code" href="http://www.trivoo.net" id="get-map-data">trivoo</a> -->
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <footer>
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="widget">
                                <address style="width:60%;float: left;">
                                    <strong>{{$t('message.addr')}}</strong><br>
                                    {{$t('message.addrcon')}}
                                </address>
                                <p style="margin-left:5%;width:30%;float: left;">
                                    <strong>{{$t('message.widgetCn')}}</strong><br>
                                    <i class="icon-phone"></i> {{$t('message.fixedTelephone')}} <br>
                                    <i class="icon-envelope-alt"></i> leo@cflytrip.com
                                </p>
                            </div>
                        </div>
                        <!-- <div class="col-lg-3">
                            <div class="widget">
                                <h5 class="widgetheading"> {{$t('message.domestic')}} </h5>
                                <ul class="link-list">
                                    <li><a href="https://www.airchina.com.cn/" target="_blank">{{$t('message.flinkCon')}}</a></li>
                                    <li><a href="https://www.ceair.com/" target="_blank">{{$t('message.flinkCon2')}}</a></li>
                                    <li><a href="https://www.csair.com/" target="_blank">{{$t('message.flinkCon3')}}</a></li>
                                    <li><a href="https://www.hnair.com/" target="_blank">{{$t('message.flinkCon4')}}</a></li>
                                    <li><a href="https://www.cdal.com.cn" target="_blank">{{$t('message.flinkCon5')}}</a></li>
                                    <li><a href="https://www.loongair.cn" target="_blank">{{$t('message.flinkCon6')}}</a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div class="widget">
                                <h5 class="widgetheading">{{$t('message.international')}}</h5>
                                <ul class="link-list">
                                    <li><a href="https://www.vietjet-air.com/" target="_blank">{{$t('message.flinkCon7')}}</a></li>
                                    <li><a href="https://www.koreanair.com/" target="_blank">{{$t('message.flinkCon8')}}</a></li>
                                    <li><a href="https://www.ana.co.jp/" target="_blank">{{$t('message.flinkCon9')}}</a></li>
                                    <li><a href="https://www.hkexpress.com/" target="_blank">{{$t('message.flinkCon10')}}</a></li>
                                    <li><a href="https://www.flyasiana.com/" target="_blank">{{$t('message.flinkCon11')}}</a></li>
                                    <li><a href="https://www.united.com/" target="_blank">{{$t('message.flinkCon12')}}</a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-3">
                            <div class="widget">
                                <h5 class="widgetheading">{{$t('message.platform')}}</h5>
                                <ul class="link-list">
                                    <li><a href="https://www.ctrip.com/" target="_blank">{{$t('message.flinkCon13')}}</a></li>
                                    <li><a href="https://www.qunar.com/" target="_blank">{{$t('message.flinkCon14')}}</a></li>
                                    <li><a href="https://www.ly.com/" target="_blank">{{$t('message.flinkCon15')}}</a></li>
                                    <li><a href="https://www.fliggy.com/" target="_blank">{{$t('message.flinkCon16')}}</a></li>
                                    <li><a href="https://www.meituan.com/" target="_blank">{{$t('message.flinkCon17')}}</a></li>
                                    <li><a href="https://buyer.pkfare.com/" target="_blank">{{$t('message.flinkCon18')}}</a></li>
                                </ul>
                            </div>
                        </div> -->
                    </div>
                </div>
                <div id="sub-footer">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="copyright">
                                    <p>
                                        <a href="https://beian.miit.gov.cn/" target="_blank">湘ICP备2020020380号-1</a>
                                        <span>&copy; Copyright ©2024 晨飞旅业 All Rights Reserved. </span>
                                    </p>
                                </div>
                            </div>
                            <div class="col-lg-6" style="position: relative;">
                              <a class="rztz" href="http://cx.cnca.cn/CertECloud/result/skipResultList?certNumber=05324I10341R0M%20%20%20&orgName=&fromIndex=true" target="_blank"><img class="ISO2007RZ" src="/static/img/rz2007.png" alt=""></a>
                                <!-- <ul class="social-network">
                                    <li>
                                        <a href="#" data-placement="top" title="Facebook"><i class="fa fa-facebook"></i></a>
                                    </li>
                                    <li>
                                        <a href="#" data-placement="top" title="Twitter"><i class="fa fa-twitter"></i></a>
                                    </li>
                                    <li>
                                        <a href="#" data-placement="top" title="Linkedin"><i class="fa fa-linkedin"></i></a>
                                    </li>
                                    <li>
                                        <a href="#" data-placement="top" title="Pinterest"><i class="fa fa-pinterest"></i></a>
                                    </li>
                                    <li>
                                        <a href="#" data-placement="top" title="Google plus"><i class="fa fa-google-plus"></i></a>
                                    </li>
                                </ul> -->
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
    </div>
</template>
<script>
export default {
    name: "contactd",
    data() {
        return {
            langCss: window.localStorage.getItem("lang"),
            dialogVisible: false,
            name:"",
            email:"",
            subject:"",
            message:"",
            typename:false,
            emailname:false,
            subjectname:false,
            messagename:false,
            currentUrl:''
        };
    },
    mounted() {
        let map = new BMap.Map("gmap_canvas");
        let point = new BMap.Point(113.0825, 28.2332);
        map.centerAndZoom(new BMap.Point(113.0825, 28.2332), 18);
        map.enableScrollWheelZoom(true);
        let marker1 = new BMap.Marker(new BMap.Point(113.0825, 28.2332));
        map.addOverlay(marker1);
        let opts = {
	        width : 200,     // 信息窗口宽度
	        height: 100,     // 信息窗口高度
	        title : "湖南晨飞旅业国际旅行社有限公司" , // 信息窗口标题
	        message:"新长海数码中心A座2104"
	    }
	    let infoWindow = new BMap.InfoWindow("地址：长沙经济技术开发区泉塘街道板仓南路29号和向阳路10号新长海中心服务外包基地3栋A座2104", opts);  // 创建信息窗口对象
	    marker1.addEventListener("click", function(){
		    map.openInfoWindow(infoWindow, point); //开启信息窗口
	    });
    },
    methods: {
        namefcous(){
            this.typename = false;
        },
        emailfcous(){
            this.emailname = false;
        },
        subjectfcous(){
            this.subjectname = false;
        },
        messagefcous(){
            this.messagename = false;
        },
        submit(){
            let that = this;
            let pattern = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
            this.name = this.name.trim()
            this.subject = this.subject.trim();
            this.message = this.message.trim();
            if(!this.name){
                this.typename = true;
                return
            }
            if(!pattern.test(this.email)){
                this.emailname = true;
                return
            }
            if(!this.subject){
                this.subjectname = true;
                return
            }
            if(!this.message){
                this.messagename = true;
                return
            }
            let star = `&SEARCH_PERSONNAME=${this.name}&SEARCH_MAIL=${this.email}&SEARCH_THEME=${this.subject}&SEARCH_CONTENT=${this.message}`;
            that.$message({
                message: that.$t("message.success"),
                type: "success"
            });
            // $.ajax({
            //     url:'',//https://wechat.51feixing.com:12443/servlet/ServiceServlet?isf_methodName=abnormalWarn'+star
            //     type:'GET',
            //     dataType: "JSONP",
            //     jsonpCallback: "callbackFunction",
            //     success:function(data){
            //         if(data === true){
            //             that.name="",
            //             that.email="",
            //             that.subject="",
            //             that.message="",
            //             that.$message({
            //                 message: that.$t("message.success"),
            //                 type: "success"
            //             });
            //         }else{
            //             that.name="",
            //             that.email="",
            //             that.subject="",
            //             that.message="",
            //             that.$message({
            //                 message: that.$t("message.error"),
            //                 type: "error"
            //             });
            //         }
            //     },
            //     error: function(jqXHR, textStatus, errorThrown) {
            //             that.$message({
            //                 message: that.$t("message.error"),
            //                 type: "error"
            //             });
            //         console.log("Error: " + textStatus + " - " + errorThrown);
            //     }
            // })
        },
        switchLang(lang) {
            this.$i18n.locale = lang;
            //把语言保存在localStorage中
            localStorage.setItem("lang", lang);
            //切换父级class
            this.langCss = lang;
        },
        handleClose(done) {
            this.$confirm(this.$t("message.confirm")) //js内部切换
                .then(_ => {
                    done();
                }).catch(_ => { });
        }
    }
};
</script>
<!-- <script type="text/javascript" src="http://maps.google.com/maps/api/js?sensor=false"></script>
<script type="text/javascript">
    function init_map(){
        var myOptions = {
            zoom:14,
            center:new google.maps.LatLng(40.805478,-73.96522499999998),
            mapTypeId: google.maps.MapTypeId.ROADMAP
        };
        map = new google.maps.Map(document.getElementById("gmap_canvas"), myOptions);
        marker = new google.maps.Marker({map: map,position: new google.maps.LatLng(40.805478, -73.96522499999998)});
        infowindow = new google.maps.InfoWindow({content:"<b>The Breslin</b><br/>2880 Broadway<br/> New York" });
        google.maps.event.addListener(marker, "click", function(){
            infowindow.open(map,marker);
        });
        infowindow.open(map,marker);
    }
    google.maps.event.addDomListener(window, 'load', init_map);
</script> -->
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.vue-css button {
    width: 150px;
}

.en .vue-css button {
    color: steelblue;
}

.cn .vue-css button {
    color: #666;
}

.ja .vue-css button {
    color: seagreen;
}

.xz {
    color: #37A691
}
</style>
<style>
#gmap_canvas img {
    max-width: none !important;
    background: none !important
}
</style>



// WEBPACK FOOTER //
// src/views/contacts/contact.vue